import { Component,Inject,Optional} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-blank-check',
    templateUrl: './dialog-blank-check.component.html',
    styleUrls: ['./dialog-blank-check.component.css'],
    standalone: false
})
export class DialogBlankCheckComponent {
  local_data:any;
  constructor(
    public dialogRef: MatDialogRef<DialogBlankCheckComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: string) { 
      this.local_data = data;
    }

    doAction(){
      this.dialogRef.close({data:this.local_data});
    }
  
    closeDialog(){
      this.dialogRef.close({data:'Cancelb'});
    }

}
